import React, { useState, useMemo } from "react";
import { Link } from "react-router-dom";
import { Helmet } from "react-helmet-async";
import { COMPANY_INFO } from "../data/siteData";

const CITIES_DATA = [
  {
    id: "slagelse",
    name: "Slagelse",
    postalCode: "4200",
    slug: "/vinduespudser-slagelse",
    image: "https://assets.auxodev.dk/assets/e7be4d2d-7d84-4f18-944c-35dc3bc1037c/gemini-generated-image-3jxk3t3jxk3t3jxk-e1763482441514.png",
    areas: "Slagelse By, Kirke Stillinge, Sørbymagle, Svenstrup"
  },
  {
    id: "slots-bjergby",
    name: "Slots Bjergby",
    postalCode: "4200",
    slug: "/vinduespudser-slots-bjergby",
    image: "https://assets.auxodev.dk/assets/e7be4d2d-7d84-4f18-944c-35dc3bc1037c/nf-1-5.jpg",
    areas: "Slots Bjergby By, Hashøj, Gerlev, Slagelse Syd"
  },
  {
    id: "soroe",
    name: "Sorø",
    postalCode: "4180",
    slug: "/vinduespudser-soroe",
    image: "https://assets.auxodev.dk/assets/e7be4d2d-7d84-4f18-944c-35dc3bc1037c/hero-soroe-vinduespudsning.png",
    areas: "Sorø Centrum, Pedersborg, Fjenneslev, Dianalund, Stenlille, Ruds Vedby"
  },
  {
    id: "skaelskoer",
    name: "Skælskør",
    postalCode: "4230",
    slug: "/vinduespudser-skaelskoer",
    image: "https://assets.auxodev.dk/assets/e7be4d2d-7d84-4f18-944c-35dc3bc1037c/hero-skaelskoer-vinduespudsning.png",
    areas: "Skælskør By, Boeslunde, Bisserup, Eggeslevmagle, Tjæreby"
  },
  {
    id: "dalmose",
    name: "Dalmose",
    postalCode: "4261",
    slug: "/vinduespudser-dalmose",
    image: "https://assets.auxodev.dk/assets/e7be4d2d-7d84-4f18-944c-35dc3bc1037c/hero-dalmose-vinduespudsning.png",
    areas: "Dalmose By, Flakkebjerg, Sønder Bjerge, Hyllested, Gimlinge"
  },
  {
    id: "naestved",
    name: "Næstved",
    postalCode: "4700",
    slug: "/vinduespudser-naestved",
    image: "https://assets.auxodev.dk/assets/e7be4d2d-7d84-4f18-944c-35dc3bc1037c/hero-naestved-vinduespudsning.png",
    areas: "Næstved Centrum, Fensmark, Holme-Olstrup, Appenæs, Mogenstrup, Rønnebæk"
  },
  {
    id: "karrebaeksminde",
    name: "Karrebæksminde",
    postalCode: "4736",
    slug: "/vindusepudser-karrebaeksminde",
    image: "https://assets.auxodev.dk/assets/e7be4d2d-7d84-4f18-944c-35dc3bc1037c/hero-karrebaeksminde-vinduespudsning.png",
    areas: "Karrebæksminde, Enø, Karrebæk, Lungene, Menstrup"
  },
  {
    id: "ringsted",
    name: "Ringsted",
    postalCode: "4100",
    slug: "/vinduespudser-ringsted",
    image: "https://assets.auxodev.dk/assets/e7be4d2d-7d84-4f18-944c-35dc3bc1037c/hero-ringsted-vinduespudsning.png",
    areas: "Ringsted By, Benløse, Kværkeby, Vetterslev, Vigersted, Jystrup"
  },
  {
    id: "hoeng",
    name: "Høng",
    postalCode: "4270",
    slug: "/vinduespudser-hoeng",
    image: "https://assets.auxodev.dk/assets/e7be4d2d-7d84-4f18-944c-35dc3bc1037c/hero-hoeng-vinduespudsning.png",
    areas: "Høng By, Løve, Finderup, Gørlev, Buerup, Reersø"
  },
  {
    id: "fuglebjerg",
    name: "Fuglebjerg",
    postalCode: "4250",
    slug: "/vindusepudser-fuglebjerg",
    image: "https://assets.auxodev.dk/assets/e7be4d2d-7d84-4f18-944c-35dc3bc1037c/hero-fuglebjerg-vinduespudsning.png",
    areas: "Fuglebjerg By, Sandved, Tornemark, Førslev, Hårslev, Kvislemark"
  }
];

const EXTRA_AREAS = [
  { name: "Korsør", zip: "4220" },
  { name: "Vemmelev", zip: "4241" },
  { name: "Dianalund", zip: "4293" },
  { name: "Stenlille", zip: "4295" },
  { name: "Gørlev", zip: "4281" },
  { name: "Forlev", zip: "4241" },
  { name: "Kirke Stillinge", zip: "4200" },
  { name: "Boeslunde", zip: "4242" }
];

export default function CitiesOverviewPage() {
  const [searchTerm, setSearchTerm] = useState("");

  const filteredCities = useMemo(() => {
    if (!searchTerm.trim()) return CITIES_DATA;
    const term = searchTerm.toLowerCase().trim();
    return CITIES_DATA.filter((city) => {
      return (
        city.name.toLowerCase().includes(term) ||
        city.postalCode.includes(term) ||
        city.areas.toLowerCase().includes(term)
      );
    });
  }, [searchTerm]);

  return (
    <>
      <Helmet>
        <title>Dækningsområder på Vestsjælland | NF-Polering</title>
        <meta
          name="description"
          content="Se vores dækningsområder på Vestsjælland: Slagelse, Sorø, Næstved, Skælskør, Ringsted, Høng, Dalmose, Karrebæksminde og Fuglebjerg. Faste priser fra 99,-."
        />
        <link rel="canonical" href="https://nf-polering.dk/daekningsomraader" />
      </Helmet>

      {/* Hero Section */}
      <section className="relative bg-slate-900 text-white overflow-hidden py-16 sm:py-24 border-b border-slate-800">
        <div className="absolute inset-0 z-0">
          <img
            src="https://assets.auxodev.dk/cdn-cgi/image/width=1920,quality=80,format=auto/assets/e7be4d2d-7d84-4f18-944c-35dc3bc1037c/img-1152_e823d4b9.jpg"
            alt="Dækningsområder på Vestsjælland - NF-Polering"
            className="w-full h-full object-cover object-center"
          />
          <div className="absolute inset-0 bg-gradient-to-r from-slate-950/90 via-slate-900/80 to-slate-950/70" />
        </div>
        <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="max-w-3xl">
            <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-cyan-500/20 text-cyan-300 border border-cyan-400/30 text-xs font-bold uppercase tracking-wider mb-4">
              <i className="fa-solid fa-location-dot" aria-hidden="true" />
              <span>Vestsjælland & omegn</span>
            </div>
            <h1 className="text-3xl sm:text-4xl lg:text-5xl font-black text-white tracking-tight uppercase">
              Dækningsområder på Vestsjælland
            </h1>
            <p className="text-base sm:text-lg text-slate-200 mt-4 leading-relaxed">
              Vi dækker hele Vestsjælland med professionel vinduespudsning, fliserens og solcellevask. Find din by herunder eller kontakt os direkte for et hurtigt tilbud.
            </p>
            <div className="flex flex-wrap items-center gap-4 pt-6">
              <a
                href={`tel:${COMPANY_INFO.phoneRaw}`}
                className="inline-flex items-center justify-center gap-2.5 px-6 py-3.5 rounded-full bg-cyan-500 hover:bg-cyan-400 text-slate-950 font-black text-sm transition-all duration-200 hover:-translate-y-1 active:scale-95 whitespace-nowrap shadow-lg shadow-cyan-500/20"
              >
                <i className="fa-solid fa-phone" aria-hidden="true" />
                <span>Ring {COMPANY_INFO.phone}</span>
              </a>
              <Link
                to="/#kontakt"
                className="inline-flex items-center justify-center gap-2 px-6 py-3.5 rounded-full bg-white/10 hover:bg-white/20 text-white border border-white/20 font-bold text-sm transition-all duration-200 hover:-translate-y-1 active:scale-95 whitespace-nowrap backdrop-blur-sm"
              >
                <span>Få et tilbud online</span>
                <i className="fa-solid fa-arrow-right text-xs" aria-hidden="true" />
              </Link>
            </div>
          </div>
        </div>
      </section>

      {/* Main Cities Overview */}
      <section className="py-12 sm:py-16 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-4 mb-8">
            <h2 className="text-xl sm:text-2xl font-black text-slate-900 uppercase tracking-tight">
              Byer og områder ({filteredCities.length})
            </h2>

            {/* Quick search input */}
            <div className="w-full sm:w-72 relative">
              <i className="fa-solid fa-magnifying-glass absolute left-3.5 top-1/2 -translate-y-1/2 text-slate-400 text-xs" aria-hidden="true" />
              <input
                type="text"
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
                placeholder="Søg by eller postnr..."
                className="w-full pl-9 pr-8 py-2 bg-slate-50 border border-slate-200 text-xs sm:text-sm text-slate-900 rounded-full focus:outline-none focus:ring-1 focus:ring-slate-900"
              />
              {searchTerm && (
                <button
                  onClick={() => setSearchTerm("")}
                  className="absolute right-2.5 top-1/2 -translate-y-1/2 text-xs text-slate-400 hover:text-slate-700"
                >
                  <i className="fa-solid fa-xmark" aria-hidden="true" />
                </button>
              )}
            </div>
          </div>

          {/* Simple Cities List/Grid */}
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
            {filteredCities.map((city) => (
              <Link
                key={city.id}
                to={city.slug}
                className="group flex items-center justify-between p-5 border border-slate-200 hover:border-slate-900 bg-white transition-colors"
              >
                <div className="flex items-baseline gap-2.5">
                  <span className="text-base font-bold text-slate-900 uppercase group-hover:text-cyan-600 transition-colors">
                    {city.name}
                  </span>
                  <span className="text-xs text-slate-400 font-medium">
                    ({city.postalCode})
                  </span>
                </div>
                <i className="fa-solid fa-arrow-right text-xs text-slate-400 group-hover:text-slate-900 group-hover:translate-x-1 transition-all" aria-hidden="true" />
              </Link>
            ))}
          </div>

          {filteredCities.length === 0 && (
            <div className="text-center py-10 bg-slate-50 border border-slate-200 p-6">
              <p className="text-sm font-semibold text-slate-900">Ingen by fundet på "{searchTerm}"</p>
              <p className="text-xs text-slate-600 mt-1">Vi kører i stort set alle byer på Vestsjælland – ring til os på 30 14 60 70.</p>
            </div>
          )}

          {/* Surrounding postal codes */}
          <div className="mt-12 pt-8 border-t border-slate-200">
            <h3 className="text-sm font-bold text-slate-900 uppercase tracking-wider mb-3">
              Tilstødende byer og postnumre:
            </h3>
            <div className="flex flex-wrap items-center gap-x-3 gap-y-1.5 text-xs sm:text-sm text-slate-700">
              {EXTRA_AREAS.map((area, idx) => (
                <React.Fragment key={area.name}>
                  <span className="text-slate-800">
                    <strong className="font-semibold text-slate-900">{area.name}</strong> ({area.zip})
                  </span>
                  {idx < EXTRA_AREAS.length - 1 && <span className="text-slate-300">•</span>}
                </React.Fragment>
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* Quick Contact Bar */}
      <section className="bg-slate-900 text-white py-12 border-t border-slate-800">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 flex flex-col sm:flex-row items-center justify-between gap-6 text-center sm:text-left">
          <div>
            <h2 className="text-xl sm:text-2xl font-black uppercase">
              Brug for vinduespudsning eller fliserens?
            </h2>
            <p className="text-slate-400 text-sm mt-1">
              Få et hurtigt og uforpligtende tilbud på din adresse.
            </p>
          </div>
          <div className="flex flex-wrap items-center justify-center gap-3">
            <a
              href={`tel:${COMPANY_INFO.phoneRaw}`}
              className="inline-flex items-center gap-2 px-6 py-3 rounded-full bg-cyan-500 hover:bg-cyan-400 text-white font-bold text-xs sm:text-sm transition-all hover:-translate-y-0.5 whitespace-nowrap"
            >
              <i className="fa-solid fa-phone" aria-hidden="true" />
              <span>30 14 60 70</span>
            </a>
            <Link
              to="/#kontakt"
              className="inline-flex items-center gap-2 px-6 py-3 rounded-full bg-white hover:bg-slate-100 text-slate-900 font-bold text-xs sm:text-sm transition-all hover:-translate-y-0.5 whitespace-nowrap"
            >
              <span>Få et tilbud</span>
              <i className="fa-solid fa-arrow-right text-[10px]" aria-hidden="true" />
            </Link>
          </div>
        </div>
      </section>
    </>
  );
}
